import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react'
import type { UseControllerProps } from 'BrokerTsLib/src/rhf'
import { useController } from 'BrokerTsLib/src/rhf'
import type { Props } from 'chakra-react-select'
import { Select } from 'chakra-react-select'

type ControlledSelectProps = UseControllerProps<any> &
  Props & {
    label: string
  }

export const ControlledSelect = ({
  control,
  name,
  id,
  label,
  rules,
  ...props
}: ControlledSelectProps) => {
  const {
    field: { onChange, onBlur, value, ref },
    fieldState: { error },
  } = useController<any>({
    name,
    control,
    rules,
  })

  return (
    <FormControl isInvalid={!!error} id={id} sx={{ w: '100%' }}>
      <FormLabel>{label}</FormLabel>

      <Select
        isMulti
        name={name}
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        loadingMessage={() => 'Načítám...'}
        {...props}
      />

      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </FormControl>
  )
}
